import { Dialog, Portal } from "@ark-ui/react";
import { cn } from "@base/lib/utils";
import type { ReactNode } from "react";

export interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

export const SidePanel = ({ open, onClose, children, className }: SidePanelProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={(details) => !details.open && onClose()} lazyMount unmountOnExit={false}>
      <Portal>
        <Dialog.Positioner className="fixed top-0 right-0 h-screen pointer-events-none z-dialog">
          <Dialog.Content
            inert={!open}
            className={cn(
              "flex flex-col w-screen h-full bg-white border-l border-gray-200 pointer-events-auto",
              "md:w-[500px]",
              "transition-transform duration-300 ease-in-out",
              open ? "translate-x-0" : "translate-x-full",
              className,
            )}
          >
            {children}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
